import styled from '@emotion/styled';

import { useI18n } from '../../../hooks/useI18nFormatters';

import { su } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';
import { icon } from '../../../theme/icon';
import { theme } from '../../../theme/theme';

import { GradientButton } from '../../../components/buttons/GradientButton';
import { Icon } from '../../../components/common/Icon';
import { Heading2Medium } from '../../../components/common/text/Heading2Medium';
import { ParagraphRegular } from '../../../components/common/text/ParagraphRegular';

import { HeaderIcons } from './HeaderIcons';
export function AlexaSettings() {
  const { i18n } = useI18n();

  return (
    <S.Root>
      <S.Content>
        <HeaderIcons>
          <Icon source={icon.apps.amazonAlexa} size="48px" />
        </HeaderIcons>

        <Heading2Medium textAlign="center">Amazon Alexa</Heading2Medium>

        <S.ContentDescription textAlign="center" lineHeight={1.5} color={theme.color.text_light}>
          {i18n.messageFormatter('settings.integrations.alexaSubtitle')}
        </S.ContentDescription>

        <GradientButton
          elementType="a"
          target="_blank"
          href="https://support.homey.app/hc/articles/360020154553"
        >
          <GradientButton.Icon
            source={glyph.core.squareArrowUpRight}
            color={theme.color.white}
            size={theme.icon.size_default}
          />

          <GradientButton.Text>
            {i18n.messageFormatter('settings.integrations.getStartedButtonTitle')}
          </GradientButton.Text>
        </GradientButton>
      </S.Content>
    </S.Root>
  );
}

AlexaSettings.pathKey = 'integrations/alexa';
AlexaSettings.icon = glyph.system.alexa;
AlexaSettings.backgroundColor = theme.color.system_alexa;

function S() {}
AlexaSettings.S = S;

S.Root = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: ${su(4)};
  margin-bottom: ${su(2)};
  flex: 1 0 auto;
`;

S.Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(380px, 100%);
`;

S.ContentDescription = styled(ParagraphRegular)`
  margin: ${su(2)} 0 ${su(4)};
`;
